__turbopack_context__.v({
  "crateContainer": "GameFeaturesSection-module__uCB84q__crateContainer",
  "featuresWrapper": "GameFeaturesSection-module__uCB84q__featuresWrapper",
});
